import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function showLeadApi(id) {
    return ApiRequest.fetchAdmin({
      method: "get",
      url: `${API_END_POINTS.SHOW_LEADS}/${id}`,
    }).then((response) => response.data);
  }